export enum SelectedPaymentMethod {
    EXISTING = "existing",
    NEW = "new",
}
